module.exports = __webpack_public_path__ + "media/images/exchange/empty-c82ee65fbdb40332438d56db4403dbeb.svg";